import TheaterRegisterContainer from './TheaterRegisterContainer';

export default TheaterRegisterContainer;
